<template>
  <div id="other-assessments" class="table-responsive">
    <table
      class="table table-sm table-striped table-hover table-bordered ledger"
    >
      <thead>
        <tr>
          <th scope="col">Assessment Name</th>
          <th scope="col">Billing</th>
          <th scope="col">Adjustments</th>
          <th scope="col">Balance</th>
          <th width="1" scope="col">&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!items.length">
          <td colspan="5" class="text-center text-muted p-3">
            No data
          </td>
        </tr>
        <tr v-for="(item, index) in items" v-bind:key="index">
          <th scope="row" class="fw-normal">
            {{ item.Description }}
          </th>
          <td>
            {{ item.TotalBilling | currency }}
          </td>
          <td>
            {{ item.TotalAdjustments | currency }}
          </td>
          <td>
            {{ item.Balance | currency }}
          </td>
          <td class="px-2">
            <button
              type="button"
              class="btn btn-primary btn-sm w-100 d-print-none text-white shadow  py-0 px-3"
              data-bs-toggle="modal"
              :data-bs-target="'#other-assessment-details-' + index + '-modal'"
            >
              Details
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <div
      v-for="(item, index) in items"
      v-bind:key="index"
      class="modal fade"
      :ref="'oad-modal' + index"
      :id="'other-assessment-details-' + index + '-modal'"
      tabindex="-1"
      :aria-labelledby="'oad-modal-label' + index"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" :id="'oad-modal-label' + index">
              Other Assessment Information
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <p class="lead">{{ item.Description }}</p>

            <table
              class="table table-sm table-striped table-hover table-borderless ledger"
            >
              <thead>
                <tr class="border-bottom">
                  <th scope="col">Assessment Name</th>
                  <th scope="col">Billing</th>
                  <th scope="col">Adjustments</th>
                  <th scope="col">Balance</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">
                    Spring Tax:
                  </th>
                  <td>
                    {{ item.Detail.billSpringTax | currency }}
                  </td>
                  <td>
                    {{ item.Detail.adjSpringTax | currency }}
                  </td>
                  <td>
                    {{ item.Detail.balSpringTax | currency }}
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    Spring Penalty:
                  </th>
                  <td>
                    {{ item.Detail.billSpringPenalty | currency }}
                  </td>
                  <td>
                    {{ item.Detail.adjSpringPenalty | currency }}
                  </td>
                  <td>
                    {{ item.Detail.balSpringPenalty | currency }}
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    Spring Annual:
                  </th>
                  <td>
                    {{ item.Detail.billSpringAnnual | currency }}
                  </td>
                  <td>
                    {{ item.Detail.adjSpringAnnual | currency }}
                  </td>
                  <td>
                    {{ item.Detail.balSpringAnnual | currency }}
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    Fall Tax:
                  </th>
                  <td>
                    {{ item.Detail.billFallTax | currency }}
                  </td>
                  <td>
                    {{ item.Detail.adjFallTax | currency }}
                  </td>
                  <td>
                    {{ item.Detail.balFallTax | currency }}
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    Fall Penalty:
                  </th>
                  <td>
                    {{ item.Detail.billFallPenalty | currency }}
                  </td>
                  <td>
                    {{ item.Detail.adjFallPenalty | currency }}
                  </td>
                  <td>
                    {{ item.Detail.balFallPenalty | currency }}
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    Fall Annual:
                  </th>
                  <td>
                    {{ item.Detail.billFallAnnual | currency }}
                  </td>
                  <td>
                    {{ item.Detail.adjFallAnnual | currency }}
                  </td>
                  <td>
                    {{ item.Detail.balFallAnnual | currency }}
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    Delq NTS Tax:
                  </th>
                  <td>
                    {{ item.Detail.billNTSTax | currency }}
                  </td>
                  <td>
                    {{ item.Detail.adjNTSTax | currency }}
                  </td>
                  <td>
                    {{ item.Detail.balNTSTax | currency }}
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    Delq NTS Pen:
                  </th>
                  <td>
                    {{ item.Detail.billNTSPen | currency }}
                  </td>
                  <td>
                    {{ item.Detail.adjNTSPen | currency }}
                  </td>
                  <td>
                    {{ item.Detail.balNTSPen | currency }}
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    Delq TS Tax:
                  </th>
                  <td>
                    {{ item.Detail.billTSTax | currency }}
                  </td>
                  <td>
                    {{ item.Detail.adjTSTax | currency }}
                  </td>
                  <td>
                    {{ item.Detail.balTSTax | currency }}
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    Delq TS Pen:
                  </th>
                  <td>
                    {{ item.Detail.billTSPen | currency }}
                  </td>
                  <td>
                    {{ item.Detail.adjTSPen | currency }}
                  </td>
                  <td>
                    {{ item.Detail.balTSPen | currency }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  }
};
</script>
